(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveal = (scope = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const nodes = scope.querySelectorAll('.pz-range-option, .pz-confidence-grid article, .pz-editorial-photo, .pz-page-prose > h2, .pz-chooser-grid > a, .pz-model, .pz-benefits > div, .pz-learning-media, .pz-learning-content, .pz-apparel-item, .pz-technology, .pz-tier-panel, .pz-faq-list > details, .pz-goggle-facts > div');
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pz-motion-visible');
          observer.unobserve(entry.target);
        }
      }
    }, { threshold: 0.12 });
    nodes.forEach((node,index) => { node.style.setProperty('--pz-reveal-delay', Math.min(index % 3 * 65,130)+'ms'); node.classList.add('pz-motion-reveal'); observer.observe(node); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => reveal(), {once:true});
  else reveal();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  window.addEventListener('pageshow', () => document.documentElement.classList.remove('pz-navigation-pending'));
})();
document.addEventListener('click',event=>{const link=event.target.closest('a[href="#pz-guide"]');if(!link)return;const guide=document.getElementById('pz-guide');if(guide)guide.open=true;});

(()=>{const run=()=>{try{const message=sessionStorage.getItem('podiumz-cart-message');if(message){document.querySelectorAll('[data-pz-cart-message]').forEach(el=>{el.textContent=message;el.hidden=false;});if(document.querySelector('#MainContent[data-template^="cart"]'))sessionStorage.removeItem('podiumz-cart-message');}}catch(e){}const widget=document.querySelector('#judgeme_product_reviews');if(widget){const sync=()=>{const average=widget.querySelector('.jdgm-rev-widg__summary-average')?.textContent?.trim(),count=widget.querySelector('.jdgm-rev-widg__summary-text')?.textContent?.trim();if(average&&count)document.querySelectorAll('[data-pz-review-link]').forEach(el=>{el.textContent=average+' · '+count+' ';});};sync();new MutationObserver(sync).observe(widget,{childList:true,subtree:true,characterData:true});}};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();})();

// Native cross-document transitions never delay a click, tap or keyboard action.
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const handleTransition = event => {
    const transition = event.viewTransition;
    if (!transition) return;
    const destination = event.activation?.entry?.url;
    if (reduced.matches || (event.type === 'pageswap' && (!destination || !new URL(destination).pathname.includes('/products/')))) {
      transition.skipTransition();
      return;
    }
    const cancel = () => transition.skipTransition();
    document.addEventListener('pointerdown', cancel, {once:true, passive:true, capture:true});
    document.addEventListener('keydown', cancel, {once:true, capture:true});
    transition.finished.finally(() => {
      document.removeEventListener('pointerdown', cancel, true);
      document.removeEventListener('keydown', cancel, true);
    });
  };
  window.addEventListener('pageswap', handleTransition);
  window.addEventListener('pagereveal', handleTransition);
  reduced.addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('.pz-motion-reveal').forEach(node => node.classList.add('pz-motion-visible'));
  });
})();

(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-pz-step]');
    if (!button) return;
    const experience = button.closest('[data-pz-experience]');
    if (!experience) return;
    const step = button.dataset.pzStep;
    experience.dataset.step = step;
    experience.querySelectorAll('[data-pz-step]').forEach(control => {
      control.setAttribute('aria-pressed', String(control === button));
    });
    experience.querySelectorAll('[data-pz-caption]').forEach(caption => {
      caption.hidden = caption.dataset.pzCaption !== step;
    });
  });
})();

(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (scope = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('pz-impact-seen');
        observer.unobserve(entry.target);
      }
    }, {threshold:0.06,rootMargin:'0px 0px -20px 0px'});
    scope.querySelectorAll('.pz-brand-proof,.pz-models-first,.pz-feature-ribbon,.pz-choice-tools,.pz-experience,.pz-tech-compare,.pz-apparel-compact,.pz-story-inner,.pz-faq-intro,.pz-retail-section>header,.pz-plus-products-head,.pz-plus-classic-link,.pz-plus-lenses>header').forEach(node => {
      if (node.classList.contains('pz-impact-ready')) return;
      node.classList.add('pz-impact-ready');
      observer.observe(node);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  reduced.addEventListener('change',event=>{
    if(event.matches) document.querySelectorAll('.pz-impact-ready').forEach(node=>node.classList.add('pz-impact-seen'));
  });
})();

(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const setup = (scope = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('pz-editorial-visible');
        observer.unobserve(entry.target);
      }
    }, {threshold:.08,rootMargin:'0px 0px -15px 0px'});
    scope.querySelectorAll('.pz-tracking>header,.pz-tracking-form,.pz-community>header,.pz-community-grid>figure,.pz-social-faq>header,.pz-social-answer,.pz-social-questions,.pz-club>h2,.pz-home-product,.pz-value-intro,.pz-value-list>article,.pz-kit-copy,.pz-kit-art,.pz-wardrobe>header,.pz-wardrobe-card,.pz-human-help>div,.pz-home-faq .pz-detail,.pz-retail-section>header,.jdgm-carousel-title').forEach((node,index) => {
      if(node.classList.contains('pz-editorial-ready')) return;
      node.style.setProperty('--pz-editorial-delay',Math.min(index%4*90,270)+'ms');
      node.classList.add('pz-editorial-ready');
      observer.observe(node);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(),{once:true});
  else setup();
  document.addEventListener('shopify:section:load',event=>setup(event.target));
  reduced.addEventListener('change',event=>{if(event.matches)document.querySelectorAll('.pz-editorial-ready').forEach(node=>node.classList.add('pz-editorial-visible'));});
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-pz-rail-direction]');
    if(!button)return;
    const rail=button.closest('[data-pz-rail-section]')?.querySelector('[data-pz-rail]');
    if(!rail)return;
    rail.scrollBy({left:Number(button.dataset.pzRailDirection)*rail.clientWidth*.88,behavior:reduced.matches?'instant':'smooth'});
  });
})();

(() => {
  document.addEventListener('click',event=>{
    const pause=event.target.closest('[data-pz-pause]');
    if(pause){
      const root=pause.closest('[data-pz-marquee]');
      const paused=pause.getAttribute('aria-pressed')!=='true';
      pause.setAttribute('aria-pressed',String(paused));root.dataset.paused=String(paused);
      pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);
      pause.querySelector('span').textContent=paused?'▶':'Ⅱ';return;
    }
    const question=event.target.closest('[data-pz-social-question]');
    if(!question)return;
    const root=question.closest('[data-pz-social-faq]');
    root.querySelectorAll('[data-pz-social-question]').forEach(button=>button.setAttribute('aria-pressed',String(button===question)));
    root.querySelectorAll('[data-pz-social-answer]').forEach(answer=>answer.hidden=answer.dataset.pzSocialAnswer!==question.dataset.pzSocialQuestion);
  });
})();

(() => {
  const init=()=>document.querySelectorAll('[data-pz-review-proof]').forEach(proof=>{
    const score=Number(proof.dataset.score),count=Number(proof.dataset.count);
    if(!(score>=0&&score<=5&&count>0))return;
    const number=new Intl.NumberFormat(document.documentElement.lang,{maximumFractionDigits:2});
    proof.querySelector('[data-pz-review-score]').textContent=number.format(score)+'/5';
    proof.querySelector('[data-pz-review-count]').textContent=proof.dataset.copy.replace('__COUNT__',number.format(count));
    proof.style.setProperty('--pz-rating-width',score/5*100+'%');
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

(() => {
 const setup=(scope=document)=>{if(!('IntersectionObserver' in window))return;
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>entry.target.classList.toggle('pz-route-active',entry.isIntersecting)),{threshold:.3});
 scope.querySelectorAll('.pz-delivery-route').forEach(node=>observer.observe(node));
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(),{once:true});else setup();
 document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
